@use "sass:math";
@use "~theme/typography";
@use "~theme/breakpoints";

$choices-width: 440px;

.container {
  flex-grow: 1; // ensures component stretches to fill the screen vertically
  width: 100%;

  @include breakpoints.desktop {
    flex: 1;
  }
}

.layout {
  display: grid;
  padding: 24px var(--mobile-gutter);
  flex-grow: 1;

  @include breakpoints.desktop {
    height: 100%;
    padding: 0;
    grid-template-columns: var(--desktop-gutter) 1fr $choices-width 1fr var(--desktop-gutter);
    grid-template-rows: 48px 1fr 48px;
    grid-template-areas:
      ". .      .       bg bg"
      ". prompt choices bg bg"
      ". .      .       bg bg";
  }
}

.divider {
  display: none;

  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    margin: 12px 0;
    border: none;
    border-bottom: 4px solid var(--blue-01);
    width: 11em;
  }
}

.prompt {
  @include breakpoints.desktop {
    grid-area: prompt;
    max-width: 350px;
  }
}

.headline {
  @include typography.heading3;
  margin: 0;
}

.choices {
  padding: 0;
  width: 100%;

  @include breakpoints.desktop {
    grid-area: choices;
    padding: 0 40px;
    margin: auto;
  }
}

.bg {
  @include breakpoints.desktop {
    grid-area: bg;
    background: no-repeat center/cover url("~images/woman.jpg");
    overflow: hidden;
    position: relative;
  }
}

// This pseudoelement is the triangular area that partially covers the bg image
.bg::after {
  @include breakpoints.desktop {
    $rotate-amount: 13deg;
    content: "";
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 100%;

    // stretch the diagonal area so it has the right height.
    height: math.div(100%, math.sin(90deg - $rotate-amount));
    background-color: var(--gray-04);
    transform-origin: bottom right;
    transform: rotate($rotate-amount);
  }
}

.button {
  @include typography.heading4;
  border: 4px solid var(--white);
  border-radius: 8px;
  cursor: pointer;
  filter: drop-shadow(0 2px 4px var(--gray-01));
  padding: 28px 16px;
  background-color: var(--white);
  margin: 8px 0;
  align-items: center;
  outline: none;
  width: 100%;
  text-align: center;

  // &:hover {
  //   border-color: var(--blue-01-at-30);
  // }

  // &:active {
  //   filter: drop-shadow(0 2px 4px var(--highlight-blue));
  //   border-color: var(--white);
  // }

  // &:focus {
  //   filter: drop-shadow(0 2px 4px var(--highlight-blue));
  // }
}
